import type { Event, Tag } from '../../domain/model/Event.types';
import type * as api from './generated/api';

export const toEventsList = (events: api.EventsList) => events.items.map(toEvent);

const toEvent = (event: api.Event): Event => ({
    id: event.id,
    eid: event.eid,
    occurredAt: event.occurred_at,
    sentToKafkaAt: event.sent_to_kafka_at,
    assetId: event.asset_id,
    accountId: event.account_id,
    deviceType: event.device_type,
    trigger: event.trigger,
    tags: event.tags.map(toTag),
});

export const toTag = (tag: api.Tag): Tag => ({
    name: tag.name,
    type: tag.type,
});
